import VueWrapper from '@/components/core/Vue/vue.wrapper';
import {DocumentationApi} from '@/sdk/api-services';
import {Component, Prop} from 'vue-property-decorator';

@Component
export default class ModelUploaderDocumentComponent extends VueWrapper {
    public readonly name = 'ModelUploaderDocumentComponent';

    @Prop({type: String, required: true})
    public readonly locationId!: string;

    file: File | null = null;
    title: string = '';

    public documentationApi: DocumentationApi = new DocumentationApi();

    public filesSelected(files: File[]): void {
        if (files.length > 0) {
            this.file = files[0];
        } else {
            this.file = null;
        }
    }

    public onUploadClick(): void {
        if (this.file && this.title) {
            this.documentationApi
                .Add3DModelDocument(this.locationId, this.file, this.title)
                .then(() => {
                    this.AlertSrv.show('success', 'File uploaded successfully');
                    this.reset();
                    this.$emit('fileUploaded', {status: 'success'});
                    this.close();
                })
                .catch(error => {
                    console.error('Error uploading file:', error);
                    this.AlertSrv.show('error', 'Error uploading file');
                });
        } else {
            this.AlertSrv.show('warning', 'Please select a file and enter a title');
        }
    }

    public reset(): void {
        this.file = null;
        this.title = '';
    }

    public open(): void {
        this.CoreSrv.OpenModal(this.name);
        this.reset();
    }

    public close(): void {
        this.CoreSrv.CloseModal(this.name);
    }
}
